import { useState, useEffect } from 'react'
import { superadminAPI, fmt, fmtFecha } from '../services/api'
import toast from 'react-hot-toast'

const PLANES = [
  { key: 'basico',  nombre: 'Básico',  precioDefault: 15000 },
  { key: 'pro',     nombre: 'Pro',     precioDefault: 20000 },
  { key: 'premium', nombre: 'Premium', precioDefault: 25000 },
]

const formVacio = {
  rut: '', razon_social: '', nombre_fantasia: '', giro: '', direccion: '', comuna: '', ciudad: '', telefono: '', email_empresa: '',
  nombre_admin: '', email_admin: '', password_admin: '',
  plan: 'basico', precio_mensual: 15000, fecha_vencimiento: ''
}

export default function Superadmin() {
  const [empresas, setEmpresas]   = useState([])
  const [cargando, setCargando]   = useState(true)
  const [modal, setModal]         = useState(false)
  const [form, setForm]           = useState(formVacio)
  const [guardando, setGuardando] = useState(false)
  const [credencialesCreadas, setCredencialesCreadas] = useState(null)
  const [empresaDetalle, setEmpresaDetalle] = useState(null)

  useEffect(() => { cargar() }, [])

  const cargar = async () => {
    setCargando(true)
    try {
      const { data } = await superadminAPI.listarEmpresas()
      setEmpresas(data)
    } catch { toast.error('Error al cargar empresas') }
    finally { setCargando(false) }
  }

  const verDetalle = async (id) => {
    try {
      const { data } = await superadminAPI.obtenerEmpresa(id)
      setEmpresaDetalle(data)
    } catch { toast.error('Error al cargar detalle') }
  }

  const cambiarPlan = (planKey) => {
    const p = PLANES.find(x => x.key === planKey)
    setForm({ ...form, plan: planKey, precio_mensual: p.precioDefault })
  }

  const crear = async () => {
    if (!form.rut || !form.razon_social || !form.nombre_fantasia) { toast.error('Completa los datos de la empresa'); return }
    if (!form.nombre_admin || !form.email_admin || !form.password_admin) { toast.error('Completa los datos del administrador'); return }

    setGuardando(true)
    try {
      const { data } = await superadminAPI.crearEmpresa(form)
      toast.success('Empresa creada correctamente 🎉')
      setCredencialesCreadas({ empresa: form.nombre_fantasia, ...data.credenciales })
      setModal(false)
      setForm(formVacio)
      cargar()
    } catch {} finally { setGuardando(false) }
  }

  const toggleActiva = async (empresa) => {
    try {
      await superadminAPI.editarEmpresa(empresa.id, { activa: !empresa.activa })
      toast.success(empresa.activa ? 'Empresa desactivada' : 'Empresa activada')
      cargar()
    } catch {}
  }

  if (cargando) return <div className="page-loading"><div className="spinner"/></div>

  const totalMRR = empresas.filter(e=>e.activa).reduce((s,e) => s + parseFloat(e.precio_mensual||0), 0)

  return (
    <div style={{padding:24, maxWidth:1200, margin:'0 auto'}}>
      <div style={{background:'#1a1a2e', margin:'-24px -24px 24px -24px', padding:'16px 24px', color:'white'}}>
        <div style={{fontSize:'12px', fontWeight:700, letterSpacing:'.1em', textTransform:'uppercase', color:'#8b8bb8'}}>Panel Superadmin</div>
        <div style={{fontSize:'20px', fontWeight:700}}>RedCaja — Gestión de clientes</div>
      </div>

      <div className="metric-grid mb-6">
        <div className="metric-card">
          <div className="metric-label">Empresas totales</div>
          <div className="metric-value">{empresas.length}</div>
        </div>
        <div className="metric-card">
          <div className="metric-label">Activas</div>
          <div className="metric-value" style={{color:'var(--color-success)'}}>{empresas.filter(e=>e.activa).length}</div>
        </div>
        <div className="metric-card">
          <div className="metric-label">MRR (ingreso mensual)</div>
          <div className="metric-value" style={{color:'var(--color-primary)'}}>{fmt(totalMRR)}</div>
        </div>
      </div>

      <div className="flex-between mb-4">
        <div className="section-title" style={{marginBottom:0}}>Empresas clientes</div>
        <button className="btn btn-primary" onClick={()=>setModal(true)}>+ Nueva empresa</button>
      </div>

      {empresas.length === 0 ? (
        <div className="empty-state"><p>Aún no hay empresas registradas</p></div>
      ) : (
        <div className="table-wrap">
          <table>
            <thead>
              <tr>
                <th>Empresa</th><th>RUT</th><th>Admin</th><th>Plan</th><th>Precio</th><th>Usuarios</th><th>Estado</th><th>Acciones</th>
              </tr>
            </thead>
            <tbody>
              {empresas.map(e => (
                <tr key={e.id} style={{opacity: e.activa ? 1 : 0.5}}>
                  <td style={{fontWeight:600}}>{e.nombre_fantasia}</td>
                  <td style={{color:'var(--color-muted)', fontSize:12}}>{e.rut}</td>
                  <td style={{color:'var(--color-muted)', fontSize:12}}>{e.email_admin || '—'}</td>
                  <td><span className="badge badge-info">{PLANES.find(p=>p.key===e.plan)?.nombre || e.plan}</span></td>
                  <td style={{fontWeight:600}}>{fmt(e.precio_mensual)}/mes</td>
                  <td>{e.n_usuarios}</td>
                  <td><span className={`badge ${e.activa?'badge-success':'badge-danger'}`}>{e.activa?'Activa':'Inactiva'}</span></td>
                  <td>
                    <div style={{display:'flex', gap:6}}>
                      <button className="btn btn-secondary" style={{padding:'4px 10px', fontSize:12}} onClick={()=>verDetalle(e.id)}>Ver</button>
                      <button className={e.activa ? 'btn btn-danger' : 'btn btn-secondary'} style={{padding:'4px 10px', fontSize:12}} onClick={()=>toggleActiva(e)}>
                        {e.activa ? 'Desactivar' : 'Activar'}
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {/* MODAL CREAR EMPRESA */}
      {modal && (
        <div style={{position:'fixed', inset:0, background:'rgba(0,0,0,.5)', display:'flex', alignItems:'center', justifyContent:'center', zIndex:1000, padding:20}}>
          <div className="card" style={{width:'100%', maxWidth:600, maxHeight:'90vh', overflowY:'auto'}}>
            <h2 style={{fontWeight:700, marginBottom:16, fontSize:18}}>Nueva empresa cliente</h2>

            <div style={{fontSize:12, fontWeight:700, color:'var(--color-muted)', textTransform:'uppercase', letterSpacing:'.05em', marginBottom:10}}>Datos de la empresa</div>
            <div className="form-row">
              <div className="form-group">
                <label className="form-label">RUT empresa *</label>
                <input className="form-input" placeholder="76.123.456-7" value={form.rut} onChange={e=>setForm({...form,rut:e.target.value})}/>
              </div>
              <div className="form-group">
                <label className="form-label">Nombre fantasía *</label>
                <input className="form-input" placeholder="Almacén Don Pedro" value={form.nombre_fantasia} onChange={e=>setForm({...form,nombre_fantasia:e.target.value})}/>
              </div>
            </div>
            <div className="form-group">
              <label className="form-label">Razón social *</label>
              <input className="form-input" placeholder="Comercial Don Pedro SpA" value={form.razon_social} onChange={e=>setForm({...form,razon_social:e.target.value})}/>
            </div>
            <div className="form-row">
              <div className="form-group">
                <label className="form-label">Giro</label>
                <input className="form-input" placeholder="Venta al por menor" value={form.giro} onChange={e=>setForm({...form,giro:e.target.value})}/>
              </div>
              <div className="form-group">
                <label className="form-label">Ciudad</label>
                <input className="form-input" placeholder="Santiago" value={form.ciudad} onChange={e=>setForm({...form,ciudad:e.target.value})}/>
              </div>
            </div>

            <div style={{fontSize:12, fontWeight:700, color:'var(--color-muted)', textTransform:'uppercase', letterSpacing:'.05em', marginBottom:10, marginTop:16}}>Usuario administrador</div>
            <div className="form-row">
              <div className="form-group">
                <label className="form-label">Nombre *</label>
                <input className="form-input" placeholder="Pedro Torres" value={form.nombre_admin} onChange={e=>setForm({...form,nombre_admin:e.target.value})}/>
              </div>
              <div className="form-group">
                <label className="form-label">Email *</label>
                <input className="form-input" type="email" placeholder="pedro@donpedro.cl" value={form.email_admin} onChange={e=>setForm({...form,email_admin:e.target.value})}/>
              </div>
            </div>
            <div className="form-group">
              <label className="form-label">Contraseña temporal *</label>
              <input className="form-input" type="text" placeholder="Mínimo 6 caracteres" value={form.password_admin} onChange={e=>setForm({...form,password_admin:e.target.value})}/>
            </div>

            <div style={{fontSize:12, fontWeight:700, color:'var(--color-muted)', textTransform:'uppercase', letterSpacing:'.05em', marginBottom:10, marginTop:16}}>Plan</div>
            <div style={{display:'flex', gap:8, marginBottom:12}}>
              {PLANES.map(p => (
                <button key={p.key} onClick={()=>cambiarPlan(p.key)} style={{
                  flex:1, padding:'10px', borderRadius:8, cursor:'pointer', textAlign:'center',
                  border: form.plan===p.key ? '2px solid var(--color-primary)' : '1px solid var(--color-border-md)',
                  background: form.plan===p.key ? 'var(--color-primary-bg)' : 'white'
                }}>
                  <div style={{fontWeight:700, fontSize:13}}>{p.nombre}</div>
                  <div style={{fontSize:11, color:'var(--color-muted)'}}>{fmt(p.precioDefault)}/mes</div>
                </button>
              ))}
            </div>
            <div className="form-row">
              <div className="form-group">
                <label className="form-label">Precio mensual (CLP)</label>
                <input className="form-input" type="number" value={form.precio_mensual} onChange={e=>setForm({...form,precio_mensual:e.target.value})}/>
              </div>
              <div className="form-group">
                <label className="form-label">Fecha de vencimiento (opcional)</label>
                <input className="form-input" type="date" value={form.fecha_vencimiento} onChange={e=>setForm({...form,fecha_vencimiento:e.target.value})}/>
              </div>
            </div>

            <div style={{display:'flex', gap:12, marginTop:20}}>
              <button className="btn btn-secondary btn-block" onClick={()=>{setModal(false); setForm(formVacio)}} disabled={guardando}>Cancelar</button>
              <button className="btn btn-primary btn-block" onClick={crear} disabled={guardando}>
                {guardando ? 'Creando...' : 'Crear empresa'}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* MODAL CREDENCIALES CREADAS */}
      {credencialesCreadas && (
        <div style={{position:'fixed', inset:0, background:'rgba(0,0,0,.5)', display:'flex', alignItems:'center', justifyContent:'center', zIndex:1000}}>
          <div className="card" style={{width:'100%', maxWidth:420, margin:20, textAlign:'center'}}>
            <div style={{fontSize:40, marginBottom:10}}>🎉</div>
            <h3 style={{fontWeight:700, marginBottom:6}}>Empresa creada</h3>
            <p style={{color:'var(--color-muted)', fontSize:13, marginBottom:16}}>Envía estas credenciales a <strong>{credencialesCreadas.empresa}</strong></p>
            <div style={{background:'var(--color-bg)', borderRadius:8, padding:16, textAlign:'left', marginBottom:16}}>
              <div style={{fontSize:12, color:'var(--color-muted)'}}>URL de acceso</div>
              <div style={{fontWeight:600, marginBottom:8}}>app.redcaja.cl</div>
              <div style={{fontSize:12, color:'var(--color-muted)'}}>Email</div>
              <div style={{fontWeight:600, marginBottom:8}}>{credencialesCreadas.email}</div>
              <div style={{fontSize:12, color:'var(--color-muted)'}}>Contraseña</div>
              <div style={{fontWeight:600}}>{credencialesCreadas.password}</div>
            </div>
            <button className="btn btn-primary btn-block" onClick={()=>setCredencialesCreadas(null)}>Listo</button>
          </div>
        </div>
      )}

      {/* MODAL DETALLE EMPRESA */}
      {empresaDetalle && (
        <div style={{position:'fixed', inset:0, background:'rgba(0,0,0,.5)', display:'flex', alignItems:'center', justifyContent:'center', zIndex:1000, padding:20}}>
          <div className="card" style={{width:'100%', maxWidth:560, maxHeight:'85vh', overflowY:'auto'}}>
            <div className="flex-between mb-4">
              <h3 style={{fontWeight:700}}>{empresaDetalle.empresa.nombre_fantasia}</h3>
              <button onClick={()=>setEmpresaDetalle(null)} style={{background:'none',border:'none',cursor:'pointer',fontSize:20}}>✕</button>
            </div>
            <div className="metric-grid" style={{marginBottom:16}}>
              <div className="metric-card"><div className="metric-label">Usuarios</div><div className="metric-value">{empresaDetalle.empresa.n_usuarios}</div></div>
              <div className="metric-card"><div className="metric-label">Productos</div><div className="metric-value">{empresaDetalle.empresa.n_productos}</div></div>
              <div className="metric-card"><div className="metric-label">Ventas totales</div><div className="metric-value">{empresaDetalle.empresa.n_ventas}</div></div>
            </div>
            <div style={{fontSize:13, marginBottom:12}}>
              <div><strong>RUT:</strong> {empresaDetalle.empresa.rut}</div>
              <div><strong>Razón social:</strong> {empresaDetalle.empresa.razon_social}</div>
              <div><strong>Ciudad:</strong> {empresaDetalle.empresa.ciudad || '—'}</div>
              <div><strong>Plan:</strong> {empresaDetalle.empresa.plan} — {fmt(empresaDetalle.empresa.precio_mensual)}/mes</div>
            </div>
            <div style={{fontWeight:700, fontSize:13, marginBottom:8}}>Usuarios</div>
            <div className="table-wrap">
              <table>
                <thead><tr><th>Nombre</th><th>Email</th><th>Rol</th><th>Estado</th></tr></thead>
                <tbody>
                  {empresaDetalle.usuarios.map(u => (
                    <tr key={u.id}>
                      <td>{u.nombre}</td>
                      <td style={{fontSize:12,color:'var(--color-muted)'}}>{u.email}</td>
                      <td>{u.rol}</td>
                      <td><span className={`badge ${u.activo?'badge-success':'badge-danger'}`}>{u.activo?'Activo':'Inactivo'}</span></td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}
